import React, {useMemo, useRef} from "react";
import { connect } from "react-redux";
import {injectIntl} from "react-intl";

import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import SvgIcon from "@mui/material/SvgIcon";
import Badge from "@mui/material/Badge";

import {showFilters} from "../../../../actions/actionFunctions";
import {GroheFilterIcon} from "../../../common/icons";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS} from "../../../../analytics";
import {getAvailableFilters} from "../../../../misc/filtersFunctions";
import {ROUTES} from "../../../../routes";
import {useLocation} from "react-router-dom";
// import {AVAILABLE_FILTERS} from "../../core/constants";

const LookSideBarFiltersButton = (props) => {

  const {intl, popupCloseClick, disabled, lookActiveCategory, selectedFilters, filtersOpened, showFilters, isMobile,
    lookActiveFeature, allFilterGroups, lookOpened, fabricatorData} = props;
  const anchorRef = useRef(null);

  const filtersButtonClick = () => {
    Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookSidebarFilters);
    showFilters(!filtersOpened);
    if (popupCloseClick) {
      popupCloseClick();
    }
  }

  const location = useLocation();
  const showWizard = location && location.pathname && location.pathname.includes(ROUTES.wizard);

  let hideButton = useMemo(() => {
    if (!lookOpened || !lookActiveCategory || (isMobile && lookActiveFeature && !showWizard) || fabricatorData.isEncore) {
      return true
    }
    const partId = lookActiveCategory || (lookActiveFeature ? lookActiveFeature.partId : "");
    const availableFilters = getAvailableFilters(null, partId, allFilterGroups);
    // const availableFilters = getAvailableFilters(null, partId, allFilterGroups).filter(filterGroup => {
    //   return AVAILABLE_FILTERS.includes(filterGroup.name)
    // });
    return !availableFilters.length;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lookActiveCategory, isMobile, lookActiveFeature, allFilterGroups, lookOpened, showWizard]);

  return (
    <li className={"look-sidebar__list-item" + (hideButton ? " look-sidebar__list-item--hidden" : "")}>
      <Tooltip title={intl.formatMessage({id:"tooltip.filters"})} placement="right">
        <Badge badgeContent={selectedFilters.length} color="primary" invisible={!selectedFilters.length}>
          <IconButton aria-label={intl.formatMessage({id:"tooltip.filters"})}
                      disabled={disabled}
                      ref={anchorRef}
                      className={"look-icon look-sidebar__button"+ (filtersOpened ? " look-icon--active2" : "")}
                      onClick={filtersButtonClick}>
            <SvgIcon>
              <GroheFilterIcon/>
            </SvgIcon>
          </IconButton>
        </Badge>
      </Tooltip>
      {/*<span className="look-tooltip"><FormattedMessage id="tooltip.filters"/></span>*/}
    </li>
  )
};

const mapStateToProps = (store) => {
  const {lookActiveCategory, lookActiveFeature, lookOpened} = store.lookState;
  const {selectedFilters, showFilters, filterGroups} = store.filterState;
  const {isMobile} = store.serverState;

  return {
    lookOpened,
    lookActiveCategory,
    selectedFilters,
    filtersOpened: showFilters,
    lookActiveFeature,
    isMobile,
    allFilterGroups: filterGroups,
    fabricatorData: store.fabricatorState,
  };
};

const mapDispatchToProps = {
  showFilters
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(LookSideBarFiltersButton)
)
